import { hasValue } from "../../../utils/functions.js";

import TableList from "../../sub-components/Generic/TableList/TableList.vue";

export default {
  name: "CategoriasDoFornecedor",
  components: {
    TableList
  },
  data() {
    return {
      headers: [
        {label:'Código', field:'Id'},
        {label:'Nome', field:'Description', classHeader:'text-left', classField:'text-left'},
        {label:'Observação', field:'Observation', classHeader:'text-left', classField:'text-left'}
      ],
      permissionIsAuthorize: 'CategoriasDosFornecedores',
      modalTitle: "Nova Categoria do Fornecedor",
      countFilter: 0,
      itemList: [],
      filter: {
        Description: null,
        Ativo: false
      },
      idField: 0,
      formField: {
        Id: 0,
        Description: null,
        Observation: null
      },
      isSeeing: false,
      loading: false,
      pOpened: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      validatedFieldForm: false
    };
  },
  watch: {
    'formField.Description': function(newVal, oldVal) {
        // Atualiza o Description do filtro sempre que o formField.Description mudar
        this.filter.Description = newVal;
    }
  },
  mounted() {
    this.ListarCategoriasDoFornecedor();
  },
  methods: {
    OpenField(item, index, eventName) {
      this.validatedFieldForm = false;
      this.ResetFormField();

      if (eventName == 'Update') {
        // Edit
        this.pOpened = index;
        this.formField = item.Id;
        this.isSeeing = false;
        this.modalTitle = "Editar Campo";
        this.BuscarCategoriasDoFornecedor();
      } else if (eventName == 'Add') {
        // Add new
        this.pOpened = null;
        this.isSeeing = false;
        this.modalTitle = "Nova Categoria do Fornecedor";
        this.ResetFormField();
      } else {
        // View
        this.pOpened = index;
        this.formField = item.Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do Campo";
        this.BuscarCategoriasDoFornecedor();
      }
      this.$bvModal.show("mFormField");
    },
    
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },

    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListarCategoriasDoFornecedor();
    },

    ResetFilter() {
      this.filter = {
        Description: null,
        Ativo: false
      };
      this.ListarCategoriasDoFornecedor();
    },

    ResetFormField() {
      this.formField = {
        Id: 0,
        Description: null
      };
    },

    SaveField() {
      this.validatedFieldForm = true;
      this.$refs.FieldValidationForm.validate().then(isValid => {
        if (isValid) {
          this.loading = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            this.AdicionarCategoriasDoFornecedor();
          } else {
            // Update
            this.EditarCategoriasDoFornecedor();
          }
        }
      });
    },

    AdicionarCategoriasDoFornecedor() {
      this.$store
        .dispatch("AddCategoriasDoFornecedor", this.formField)
        .then(() => {
          this.$makeToast("O campo foi cadastrado com sucesso.","success","Campo cadastrado");
          this.ListarCategoriasDoFornecedor();
          this.$bvModal.hide("mFormField");
        })
        .catch(error => {
          this.$makeToast("Tente novamente mais tarde.","danger","Erro ao criar campo",error);
        })
        .finally(() => {
          this.loading = false;
          this.isSeeing = false;
          this.ResetFilter();
        });
    },
    

    EditarCategoriasDoFornecedor() {
      this.$store.dispatch("EditarCategoriasDoFornecedor", this.formField)
        .then(() => {
          this.$makeToast("O Campo foi atualizado com sucesso.","success","Campo atualizado");
          this.ListarCategoriasDoFornecedor();
          this.$bvModal.hide("mFormField");
        })
        .catch(error => {
          this.$makeToast("Erro ao atualizar campo, tente novamente.","danger","Erro ao atualizar campo",error);
        })
        .finally(() => {
          this.loading = false;
          this.isSeeing = false;
        });
    },

    BuscarCategoriasDoFornecedor() {
      if (this.formField.Id != 0) {
        this.loading = true;
        this.$store.dispatch("BuscarCategoriasDoFornecedor", this.formField )
          .then(response => {
            this.formField = response;
          })
          .catch(error => {
            this.$makeToast("Um erro ocorreu ao carregar o campo","danger","Erro ao carregar o campo",error);
          })
          .finally(() => {
            this.loading = false;
            this.ResetFilter();
          });
        }
    },

    ListarCategoriasDoFornecedor() {
      this.loading = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Description)) this.countFilter++;
      if (hasValue(this.filter.Ativo)) this.countFilter++;
      let data = {
        ...this.pagination,
        "Object.Description": this.filter.Description,
        "Object.Ativo": this.filter.Ativo
      };
      delete data.TotalItems;
      this.$store.dispatch("ListarCategoriasDoFornecedor", data)
        .then(response => {
          this.itemList = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar os campos. Tente novamente.",
                          "danger","Erro ao listar os Campos",error);
        })
        .finally(() => (this.loading = false));
    },

    DeleteCategoriasDoFornecedor(Id) {
      this.formField.Ativo == true; 
      this.$store.dispatch("DeleteCategoriasDoFornecedor", { id: Id})
        .then(() => {
          this.$makeToast("O Campo foi removido com sucesso.","success","Campo removido");
          this.ListarCategoriasDoFornecedor();
          this.$bvModal.hide("mFormField");
        })
        .catch(error => {
          this.$makeToast("Tente novamente mais tarde.","danger","Erro ao remover Campo",error);
        });
    },

    ConfirmaDeleteCategoriasDoFornecedor(item, index, eventName) {
      this.$makeMsgBox("Você tem certeza que deseja remover " + item.Description + " ?",
                       "Confirmar",this.DeleteCategoriasDoFornecedor, item.Id);
    },

    preventDecimal(e) {
      if (e.code == "Comma" || e.code == "Period" || e.code == "Minus") {
        e.preventDefault();
      }
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/CategoriasDosFornecedores/CategoriasDosFornecedores.js